import React, { ReactElement } from 'react';
import { ElPrix } from './Designs/ElPrix/ElPrix';
import { Christmas } from './Designs/Christmas/Christmas';
import useSelector from '../../../redux/typedHooks';
import { Easter } from './Designs/Easter/Easter';

export const Decorations = () => {
  const decorationToShow = useSelector((state) => state.globalSettings.settings?.decoration);

  let decorationComponent: ReactElement | null;
  switch (decorationToShow) {
    case 'elprix':
      decorationComponent = <ElPrix />;
      break;
    case 'christmas':
      decorationComponent = <Christmas />;
      break;
    case 'easter':
      decorationComponent = <Easter />;
      break;
    case 'none':
    default:
      decorationComponent = null;
      break;
  }

  return decorationComponent;
};
